export default '/static/frontend/ReachDigital/12gobiking/dist/assets/ekomi-8cdd36c9.svg'